var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    viewBox: "0 0 48 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 34C22.6 34 21.4167 33.5167 20.45 32.55C19.4833 31.5833 19 30.4 19 29C19 27.6 19.4833 26.4167 20.45 25.45C21.4167 24.4833 22.6 24 24 24C25.4 24 26.5833 24.4833 27.55 25.45C28.5167 26.4167 29 27.6 29 29C29 30.4 28.5167 31.5833 27.55 32.55C26.5833 33.5167 25.4 34 24 34ZM12.7 22.7L8.5 18.4C10.4667 16.4333 12.7753 14.8753 15.426 13.726C18.0767 12.5767 20.9347 12.0013 24 12C27.0653 11.9987 29.924 12.582 32.576 13.75C35.228 14.918 37.536 16.5013 39.5 18.5L35.3 22.7C33.8333 21.2333 32.1333 20.0833 30.2 19.25C28.2667 18.4167 26.2 18 24 18C21.8 18 19.7333 18.4167 17.8 19.25C15.8667 20.0833 14.1667 21.2333 12.7 22.7ZM4.2 14.2L0 10C3.06667 6.86667 6.65 4.41667 10.75 2.65C14.85 0.883333 19.2667 0 24 0C28.7333 0 33.15 0.883333 37.25 2.65C41.35 4.41667 44.9333 6.86667 48 10L43.8 14.2C41.2333 11.6333 38.2587 9.62533 34.876 8.176C31.4933 6.72667 27.868 6.00133 24 6C20.132 5.99867 16.5073 6.724 13.126 8.176C9.74467 9.628 6.76933 11.636 4.2 14.2Z",
    fill: "#134021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.27725003177379dc6da436b797f5c274.svg";
export { ForwardRef as ReactComponent };